export default __webpack_public_path__ + "static/media/Countdown.82fc8df8.aac";